var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#18A7B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8278 19.7482C30.001 13.9287 25.7281 11 20 11C14.2689 11 9.99896 13.9287 7.17219 19.7511C7.0588 19.9857 7 20.242 7 20.5015C7 20.7609 7.0588 21.0172 7.17219 21.2518C9.99896 27.0713 14.2719 30 20 30C25.7311 30 30.001 27.0713 32.8278 21.2489C33.0574 20.7768 33.0574 20.229 32.8278 19.7482ZM20 27.2605C23.9887 27.2605 27.2222 24.0952 27.2222 20.1907C27.2222 16.2861 23.9887 13.1208 20 13.1208C16.0113 13.1208 12.7778 16.2861 12.7778 20.1907C12.7778 24.0952 16.0113 27.2605 20 27.2605Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4028 17.8501C24.8259 18.2642 24.8259 18.9357 24.4028 19.3498L19.9663 23.6927C19.7632 23.8916 19.4876 24.0033 19.2003 24.0033C18.913 24.0033 18.6374 23.8916 18.4343 23.6927L15.6615 20.9784C15.2384 20.5642 15.2384 19.8928 15.6615 19.4786C16.0845 19.0645 16.7705 19.0645 17.1935 19.4786L19.2003 21.4431L22.8707 17.8501C23.2938 17.4359 23.9797 17.4359 24.4028 17.8501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckUp);
export default __webpack_public_path__ + "static/media/check-up.66c7eb281d9bd26996e1f97d34c09d3e.svg";
export { ForwardRef as ReactComponent };